import { AxiosInstance } from 'axios';
import baseAxios from '@/helpers/forms/axios';

export interface fulfillmentInterface {
    id: string
    created_at: string
    package_identifier: string
    provider_confirmed_at: string | null
}

export interface fulfillmentRequestInterface {
    id: string
    created_at: string
    order_id: number
    provider_fulfillment_order_id: string
    received_at: string
    is_accepted: boolean
    accepted_at: string | null
    is_rejected: boolean
    rejected_at: string | null
    fulfillments?: fulfillmentInterface[]
}

export default (axios: AxiosInstance = baseAxios): { requestFulfillmentForOrder: (orderId: number) => Promise<void>; rejectFulfillmentRequest: (fulfillmentRequestId: string) => Promise<void>; } => ({
    requestFulfillmentForOrder: async (orderId: number): Promise<void> => {
        return await axios.post('/api/fulfillment/request-fulfillment', {
            order_id: orderId,
        });
    },

    rejectFulfillmentRequest: async (fulfillmentRequestId: string): Promise<void> => {
        return await axios.post('/api/fulfillment/reject', {
            fulfillment_request_id: fulfillmentRequestId,
        });
    },
});
